var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIinima(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 400,
    viewBox: "0 0 311 657",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3549 73.3732C24.3549 46.7936 45.3142 25.3378 71.0641 25.3378C96.8141 25.3378 117.773 47.1139 117.773 73.3732C117.773 99.6325 96.8141 121.409 71.0641 121.409C45.3142 121.409 24.3549 99.6325 24.3549 73.3732Z",
    stroke: "#C13427",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0639 145.747C32.4389 145.747 1 113.403 1 73.3733C1 33.3438 32.4389 1 71.0639 1C109.689 1 141.128 33.3438 141.128 73.3733C141.128 113.083 109.689 145.747 71.0639 145.747ZM71.0639 49.3556C58.1889 49.3556 48.0086 59.9234 48.0086 73.053C48.0086 86.1827 58.4883 96.7505 71.0639 96.7505C83.9388 96.7505 94.1191 86.1827 94.1191 73.053C94.1191 60.2436 83.6394 49.3556 71.0639 49.3556Z",
    stroke: "#C13427",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.197 197.945H36.6305V631.224H105.197V197.945Z",
    stroke: "#C13427",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.552 655.562H12.9768V173.607H128.552V655.562ZM60.2849 606.886H81.5436V222.283H60.2849V606.886Z",
    stroke: "#C13427",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M286.346 582.868C286.346 609.448 265.386 630.904 239.636 630.904C213.886 630.904 192.927 609.128 192.927 582.868C192.927 556.289 213.886 534.833 239.636 534.833C265.386 534.833 286.346 556.609 286.346 582.868Z",
    stroke: "#C13427",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M239.936 510.495C278.561 510.495 310 542.839 310 582.868C310 622.898 278.561 655.242 239.936 655.242C201.311 655.242 169.872 622.898 169.872 582.868C169.573 543.159 201.012 510.495 239.936 510.495ZM239.936 606.886C252.811 606.886 262.991 596.318 262.991 583.189C262.991 570.059 252.512 559.491 239.936 559.491C227.061 559.491 216.881 570.059 216.881 583.189C216.581 595.998 227.061 606.886 239.936 606.886Z",
    stroke: "#C13427",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M274.07 25.0177H205.503V458.297H274.07V25.0177Z",
    stroke: "#C13427",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M182.148 1H297.723V482.955H182.148V1ZM250.415 49.3556H229.157V433.959H250.415V49.3556Z",
    stroke: "#C13427",
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIinima);
export default __webpack_public_path__ + "static/media/iinima.929c11a576cc26e8da35efa2dc499417.svg";
export { ForwardRef as ReactComponent };